import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@/components/ui-v2';

export interface PromoteOrgAdminModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    memberName: string;
    orgName: string;
    submitting?: boolean;
}

export default function PromoteOrgAdminModal({
    open,
    onClose,
    onConfirm,
    memberName,
    orgName,
    submitting,
}: PromoteOrgAdminModalProps) {
    return (
        <Modal open={open} onClose={onClose} width={460}>
            <ModalHeader onClose={onClose}>Promote to organization admin</ModalHeader>
            <ModalBody>
                <p className="text-sm text-gray-800 mb-3">
                    Make <span className="font-medium">{memberName}</span> an admin of{' '}
                    <span className="font-medium">{orgName}</span>?
                </p>
                <ul className="text-xs text-gray-600 list-disc pl-5 space-y-1.5 mb-3">
                    <li>Org admins can do anything in every workspace in this organization.</li>
                    <li>Their existing workspace-specific roles will be replaced by org-wide access.</li>
                    <li>They'll receive an email about the change.</li>
                </ul>
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={onClose} disabled={submitting}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onConfirm} disabled={submitting}>
                    {submitting ? 'Promoting…' : 'Make org admin'}
                </Button>
            </ModalFooter>
        </Modal>
    );
}
